import React from 'react';
import { AdminStatsOut } from '../../services/apiClient';

interface Props {
  stats: AdminStatsOut;
}

const euros = (cents: number) =>
  new Intl.NumberFormat('en-IE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(cents / 100);

const AdminStats: React.FC<Props> = ({ stats }) => (
  <div className="admin-stats">
    <div className="admin-stats-cards">
      <div className="admin-stat-card">
        <span className="admin-stat-value">{stats.total_users}</span>
        <span className="admin-stat-label">users</span>
      </div>
      <div className="admin-stat-card">
        <span className="admin-stat-value">{stats.onboarded_users}</span>
        <span className="admin-stat-label">onboarded</span>
      </div>
      <div className="admin-stat-card">
        <span className="admin-stat-value">{stats.subscribers_monthly + stats.subscribers_yearly}</span>
        <span className="admin-stat-label">{stats.subscribers_monthly} monthly · {stats.subscribers_yearly} yearly</span>
      </div>
      <div className="admin-stat-card">
        <span className="admin-stat-value">{euros(stats.mrr_cents)}</span>
        <span className="admin-stat-label">MRR</span>
      </div>
      <div className="admin-stat-card">
        <span className="admin-stat-value">{stats.users_with_report}</span>
        <span className="admin-stat-label">report</span>
      </div>
    </div>
    <p className="admin-stats-deltas">
      <span>+{stats.signups_7d} signups / 7d</span>
      <span>+{stats.signups_30d} / 30d</span>
      <span>+{stats.new_subscriptions_7d} subs / 7d</span>
      <span>+{stats.new_subscriptions_30d} / 30d</span>
      <span>−{stats.cancellations_7d} cancels / 7d</span>
      <span>−{stats.cancellations_30d} / 30d</span>
      <span>{stats.past_due} past due</span>
      <span>{stats.comped_active} comped</span>
      {stats.legacy_credits_outstanding > 0 && (
        <span>{stats.legacy_credits_outstanding} legacy credits</span>
      )}
    </p>
  </div>
);

export default AdminStats;
